import React, { useRef, useCallback } from 'react';
import { useHandTracking } from '../hooks/useHandTracking';
import './SignDetector.css';

function SignDetector({ onSignDetected, onAddToSentence }) {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const handleSignDetected = useCallback((gesture) => {
    onSignDetected(gesture);
  }, [onSignDetected]);

  const { isLoading, error, isTracking } = useHandTracking({
    onSignDetected: handleSignDetected,
    videoRef,
    canvasRef,
  });

  return (
    <div className="detector">
      <div className="detector-header">
        <h2 className="detector-title">Live Camera Feed</h2>
        <div className={`tracking-badge ${isTracking ? 'tracking' : ''}`}>
          <span className="tracking-dot"></span>
          {isTracking ? 'Hand Detected' : 'No Hand'}
        </div>
      </div>

      <div className="video-container">
        <video
          ref={videoRef}
          className="video-feed"
          autoPlay
          muted
          playsInline
        />
        <canvas ref={canvasRef} className="landmark-canvas" />

        {isLoading && (
          <div className="overlay-message loading">
            <div className="spinner"></div>
            <p>Loading AI Hand Tracking...</p>
            <span>Initializing MediaPipe</span>
          </div>
        )}

        {error && (
          <div className="overlay-message error">
            <div className="error-icon">⚠️</div>
            <p>{error}</p>
            <span>Check browser camera permissions</span>
          </div>
        )}

        {!isLoading && !error && !isTracking && (
          <div className="hand-guide">
            <div className="guide-hand">✋</div>
            <p>Show your hand to the camera</p>
          </div>
        )}

        <div className="video-corner top-left"></div>
        <div className="video-corner top-right"></div>
        <div className="video-corner bottom-left"></div>
        <div className="video-corner bottom-right"></div>
      </div>

      <div className="detector-tips">
        <div className="tip">💡 Keep hand centered and well-lit</div>
        <div className="tip">📏 Arm's length from camera</div>
        <div className="tip">✋ Hold sign steady for 1 second</div>
      </div>
    </div>
  );
}

export default SignDetector;
